export default {
    namespaced: true,
    state: {
        fahrzeugDatens: [
            {
                name: "Krafträder",
                produktionsanzahl: null,
                isChecked: false
            },
            {
                name: "Personenkraftwagen",
                produktionsanzahl: null,
                isChecked: false
            },
            {
                name: "Kraftomnibusse",
                produktionsanzahl: null,
                isChecked: false
            },
            {
                name: "Lastkraftwagen",
                produktionsanzahl: null,
                isChecked: false
            },
            {
                name: "Sonstige Kraftfahrzeuge",
                produktionsanzahl: null,
                isChecked: false
            },
            {
                name: "Kraftfahrzeuganhänger",
                produktionsanzahl: null,
                isChecked: false
            }
        ]
    },
    getters: {
        fahrzeugDatens (state) {
            return state.fahrzeugDatens
        }
    },
    mutations: {
        fahrzeugDatens (state, fahrzeugDatens) {
            state.fahrzeugDatens = fahrzeugDatens
        },

        reset(state) {
            for(let i=0; i<state.fahrzeugDatens.length; i++) {
                if(state.fahrzeugDatens[i].isChecked) {
                    state.fahrzeugDatens[i].produktionsanzahl = null
                    state.fahrzeugDatens[i].isChecked = false
                }
            }
        }
    },
    actions: {

    }
}
